import React from "react";
import WarehouseTable from "src/pages/warehouse";

export default function WarehousePage() {
  return <WarehouseTable />;
}
